import React from 'react';
import {
  isCompanyCheckupFlow,
  isCustomerCheckupFlow,
  isRiskAnalysisFlow,
  isSalesConversationFlow,
} from '../../../../../../common/src/utils/globalVariables';
import MultiSelectRiskAnalysis from '../../../../../../risk-analysis/src/components/input/MultiSelectInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import MultiselectInputComponent from '../../company-scan-inputs/multiselect/MultiselectInputComponent';
import MultiselectInputComponentAdvisory from './MultiselectInputComponent';

interface Props {
  question: FlowsQuestion;
}

const MultiSelectPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  if (isSalesConversationFlow()) {
    return <MultiselectInputComponentAdvisory question={question} />;
  }

  if (
    isRiskAnalysisFlow() ||
    isCustomerCheckupFlow() ||
    isCompanyCheckupFlow()
  ) {
    return <MultiSelectRiskAnalysis question={question} />;
  }

  return <MultiselectInputComponent question={question} />;
};

export default MultiSelectPicker;
